import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "sonner"
import { registerKgSw } from "@cogo/kg-sw"
import { WebMCPProvider } from "@cogo/webmcp-runtime/react"
import { AuthProvider } from "./auth/auth-context"
import { App } from "./App"
import { KgProvider } from "./kg/kg-provider"
import { isKgBrowserEnabled } from "./kg/kg-client"
import { CogoAgent } from "./agent/CogoAgent"
import { createStarterRegistry, STARTER_ONTOLOGY } from "./agent/webmcp-setup"
import { STARTER_AGENT_CONFIG } from "./agent/agent-config"
import "./globals.css"

// Phase 2a Step 7 — register the Cogo KG Service Worker for offline shard
// caching + cross-tab invalidation. Gated behind the same VITE_KG_BROWSER
// feature flag as the kg-browser integration; no-ops when flag is off.
if (isKgBrowserEnabled()) {
  registerKgSw({ strategy: "on-load", verbose: import.meta.env.DEV }).catch(
    (err: unknown) => console.debug("[main] kg-sw registration error:", err),
  )
}

// Phase B — agentic runtime wrap (docs/superpowers/plans/2026-04-20-
// agentic-app-integration.md). Root-level registry is seeded from the
// static ontology-manifest.json; downstream AppV2 mounts can attach
// their own runtime-backed handlers via useCogoWebMCP.
const webmcpRegistry = createStarterRegistry()

// Support both tenant mode (#cogo-app) and dev mode (#root)
const container = document.getElementById("cogo-app") || document.getElementById("root")!

createRoot(container).render(
  <StrictMode>
    <KgProvider>
      <WebMCPProvider
        registry={webmcpRegistry}
        ontology={STARTER_ONTOLOGY}
        persona={STARTER_AGENT_CONFIG.persona}
      >
        <AuthProvider>
          <App />
          <CogoAgent />
          <Toaster position="top-right" />
        </AuthProvider>
      </WebMCPProvider>
    </KgProvider>
  </StrictMode>,
)
